import { render } from "./ProfileAbout.vue?vue&type=template&id=d99e5f98&scoped=true&ts=true"
import script from "./ProfileAbout.vue?vue&type=script&lang=ts"
export * from "./ProfileAbout.vue?vue&type=script&lang=ts"

import "./ProfileAbout.vue?vue&type=style&index=0&id=d99e5f98&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d99e5f98"]])

export default __exports__